import { useFormikContext } from 'formik'
import React from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import { editRevenueCenterSucceeded } from 'store/RevenueCenters/actions'

const LocationSettingsSection = ({ id }) => {
  const history = useHistory()
  const dispatch = useDispatch()

  const { values } = useFormikContext()

  const onClickLocationSettings = () => {
    const {
      description,
      externalRefId,
      filterData,
      localTime,
      name,
      businessEndTime,
    } = values
    const editedRevenueCenterValues = {
      description,
      externalRefId,
      filterData,
      localTime,
      name,
      businessEndTime,
    }

    dispatch(editRevenueCenterSucceeded(editedRevenueCenterValues))
    history.push(`${history.location.pathname}/location-settings`)
  }
  return (
    <section key={id}>
      <h2 className="header-title -more-space" id={id}>
        Settings
      </h2>
      <button
        className="btn -outline -block"
        onClick={onClickLocationSettings}
        type="button"
      >
        Location Settings
      </button>
    </section>
  )
}

export default LocationSettingsSection
